<template>
  <b-row>
    <b-col>
      <b-button v-b-toggle="'collapse-' + index" variant="default" class="w-100 mb-1 mt-1">#{{index + 1}}{{ documentPositionHeader }}</b-button>
      <b-collapse :id="'collapse-' + index" v-model="showCollapse">
        <b-row>
          <b-col>
            <div class="form-group">
              <label
                      for="exsbposition_item"
                      class="form-control-label">{{$t('views.exsbdocument.form.positions.item')}}:</label>
              <fg-input :error="violations.item">
                <el-select
                        id="exsbposition_item"
                        :class="['select-default', isInvalid('item') ? 'select-danger' : '']"
                        :placeholder="$t('views.exsbdocument.form.positions.item')"
                        :disabled="ordersDocument"
                        filterable
                        v-model="documentPosition.item">
                  <el-option v-for="option in itemsArray"
                             class="select-default"
                             :value="option['@id']"
                             :label="option.name"
                             :key="option['@id']">
                  </el-option>
                </el-select>
              </fg-input>
              <div
                      v-if="isInvalid('item')"
                      class="invalid-feedback">{{ violations.item }}</div>
            </div>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <div class="form-group">
                  <label
                          for="exsbposition_warehouse"
                          class="form-control-label">{{$t('views.exsbdocument.form.positions.warehouse')}}:</label>
                  <fg-input :error="violations.delivery">
                    <el-select
                            id="exsbposition_warehouse"
                            :class="['select-default', isInvalid('warehouse') ? 'select-danger' : '']"
                            :placeholder="$t('views.exsbdocument.form.positions.warehouse')"
                            filterable
                            v-model="documentPosition.warehouse">
                      <el-option v-for="option in warehouses"
                                 class="select-default"
                                 :value="option['@id']"
                                 :label="option.name"
                                 :key="option['@id']">
                      </el-option>
                    </el-select>
                  </fg-input>
                  <div
                          v-if="isInvalid('warehouse')"
                          class="invalid-feedback">{{ violations.warehouse }}</div>
                </div>
              </b-col>
              <b-col>
                <div class="form-group">
                  <label
                          for="exsbposition_warehouseQuantity"
                          class="form-control-label">{{$t('views.exsbdocument.form.positions.warehouseQuantity')}}:</label>
                  <input
                          id="exsbposition_warehouseQuantity"
                          v-model="documentPosition.warehouseQuantity"
                          :class="['form-control', isInvalid('warehouseQuantity') ? 'is-invalid' : '']"
                          type="number"
                          placeholder="0"
                          disabled
                          @input="handleUpdateField('warehouseQuantity', $event.target.value)">
                  <div
                          v-if="isInvalid('warehouseQuantity')"
                          class="invalid-feedback">{{ violations.warehouseQuantity }}</div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-if="documentType !== 1 && documentType !== 2 && documentType !== 3 && documentType !== 4">
            <b-row>
              <b-col>
                <div class="form-group float-left">
                  <label
                          for="exsbposition_newWarehouse"
                          class="form-control-label">{{$t('views.exsbdocument.form.positions.newWarehouse')}}:</label>
                  <fg-input :error="violations.delivery">
                    <el-select
                            id="exsbposition_newWarehouse"
                            :class="['select-default', isInvalid('newWarehouse') ? 'select-danger' : '']"
                            :placeholder="$t('views.exsbdocument.form.positions.newWarehouse')"
                            filterable
                            v-model="documentPosition.newWarehouse">
                      <el-option v-for="option in warehouses"
                                 class="select-default"
                                 :value="option['@id']"
                                 :label="option.name"
                                 :key="option['@id']">
                      </el-option>
                    </el-select>
                  </fg-input>
                  <div
                          v-if="isInvalid('newWarehouse')"
                          class="invalid-feedback">{{ violations.newWarehouse }}</div>
                </div>
              </b-col>
              <b-col>
                <div class="form-group float-left">
                  <label
                          for="exsbposition_newWarehouseQuantity"
                          class="form-control-label">{{$t('views.exsbdocument.form.positions.newWarehouseQuantity')}}:</label>
                  <input
                          id="exsbposition_newWarehouseQuantity"
                          v-model="documentPosition.newWarehouseQuantity"
                          :class="['form-control', isInvalid('newWarehouseQuantity') ? 'is-invalid' : '']"
                          type="number"
                          placeholder="0"
                          disabled
                          @input="handleUpdateField('newWarehouseQuantity', $event.target.value)">
                  <div
                          v-if="isInvalid('newWarehouseQuantity')"
                          class="invalid-feedback">{{ violations.newWarehouseQuantity }}</div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2" class="pr-1">
            <div class="form-group">
              <label
                      for="exsbposition_quantity"
                      class="form-control-label">{{$t('views.exsbdocument.form.positions.quantity')}}:</label>
              <input
                      id="exsbposition_quantity"
                      v-model="documentPosition.quantity"
                      :class="['form-control', isInvalid('quantity') ? 'is-invalid' : '']"
                      :disabled="ordersDocument"
                      type="number"
                      placeholder=""
                      @input="handleUpdateField('quantity', $event.target.value)">
              <div
                      v-if="isInvalid('quantity')"
                      class="invalid-feedback">{{ violations.quantity }}</div>
            </div>
          </b-col>
          <b-col cols="1" v-if="documentType !== 3 && documentType !== 4" class="pr-1 pl-1">
            <div class="form-group">
              <label
                      for="exsbposition_discount"
                      class="form-control-label">{{$t('views.exsbdocument.form.positions.discount')}}:</label>
              <input
                      id="exsbposition_discount"
                      v-model="documentPosition.discount"
                      :class="['form-control', isInvalid('discount') ? 'is-invalid' : '']"
                      :disabled="ordersDocument"
                      type="text"
                      placeholder="0"
                      v-b-tooltip.hover :title="$t('views.exsbdocument.form.positions.discountTooltip')"
                      @input="handleUpdateField('discount', $event.target.value)">
              <div
                      v-if="isInvalid('discount')"
                      class="invalid-feedback">{{ violations.discount }}</div>
            </div>
          </b-col>
          <b-col cols="3" class="pr-1 pl-1">
            <b-row>
              <b-col class="pr-1">
                <div class="form-group">
                  <label
                          for="exsbposition_pricePerUnitNetto"
                          class="form-control-label">{{$t('views.exsbdocument.form.positions.pricePerUnitNetto')}}:</label>
                  <input
                          id="exsbposition_pricePerUnitNetto"
                          v-model="documentPosition.pricePerUnitNetto"
                          :class="['form-control', isInvalid('pricePerUnitNetto') ? 'is-invalid' : '']"
                          type="text"
                          placeholder=""
                          :disabled="!documentPosition.vatRate || ordersDocument"
                          @input="handleUpdateField('pricePerUnitNetto', $event.target.value)">
                  <div
                          v-if="isInvalid('pricePerUnitNetto')"
                          class="invalid-feedback">{{ violations.pricePerUnitNetto }}</div>
                </div>
              </b-col>
              <b-col class="pl-1">
                <div class="form-group">
                  <label
                          for="exsbposition_valueNetto"
                          class="form-control-label">{{$t('views.exsbdocument.form.positions.valueNetto')}}:</label>
                  <input
                          id="exsbposition_valueNetto"
                          v-model="documentPosition.valueNetto"
                          :class="['form-control', isInvalid('valueNetto') ? 'is-invalid' : '']"
                          type="text"
                          placeholder=""
                          disabled
                          @input="handleUpdateField('valueNetto', $event.target.value)">
                  <div
                          v-if="isInvalid('value')"
                          class="invalid-feedback">{{ violations.valueNetto }}</div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="pr-1 pl-1">
            <div class="form-group">
              <label
                      for="exsbposition_vatRate"
                      class="form-control-label">{{$t('views.exsbdocument.form.positions.vatRate')}}:</label>
              <fg-input :error="violations.delivery">
                <el-select
                        id="exsbposition_vatRate"
                        :class="['select-default', isInvalid('vatRate') ? 'select-danger' : '']"
                        :placeholder="$t('views.exsbdocument.form.positions.vatRate')"
                        filterable
                        disabled
                        v-model="documentPosition.vatRate">
                  <el-option v-for="option in vatRates"
                             class="select-default"
                             :value="option['@id']"
                             :label="option.range"
                             :key="option['@id']">
                  </el-option>
                </el-select>
              </fg-input>
              <div
                      v-if="isInvalid('vatRate')"
                      class="invalid-feedback">{{ violations.vatRate }}</div>
            </div>
          </b-col>
          <b-col cols="3" class="pl-1">
            <b-row>
              <b-col class="pr-1">
                <div class="form-group">
                  <label
                          for="exsbposition_pricePerUnitBrutto"
                          class="form-control-label">{{$t('views.exsbdocument.form.positions.pricePerUnitBrutto')}}:</label>
                  <input
                          id="exsbposition_pricePerUnitBrutto"
                          v-model="documentPosition.pricePerUnitBrutto"
                          :class="['form-control', isInvalid('pricePerUnitBrutto') ? 'is-invalid' : '']"
                          type="text"
                          placeholder=""
                          :disabled="true"
                          @input="handleUpdateField('pricePerUnitBrutto', $event.target.value)">
                  <div
                          v-if="isInvalid('pricePerUnitBrutto')"
                          class="invalid-feedback">{{ violations.pricePerUnitBrutto }}</div>
                </div>
              </b-col>
              <b-col class="pl-1">
                <div class="form-group">
                  <label
                          for="exsbposition_valueBrutto"
                          class="form-control-label">{{$t('views.exsbdocument.form.positions.valueBrutto')}}:</label>
                  <input
                          id="exsbposition_valueBrutto"
                          v-model="documentPosition.valueBrutto"
                          :class="['form-control', isInvalid('valueBrutto') ? 'is-invalid' : '']"
                          type="text"
                          placeholder=""
                          disabled
                          @input="handleUpdateField('valueBrutto', $event.target.value)">
                  <div
                          v-if="isInvalid('value')"
                          class="invalid-feedback">{{ violations.valueBrutto }}</div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-if="documentType !== 1 && documentType !== 2 && documentType !== 3 && documentType !== 4">
          <b-col cols="3">
            <div class="form-group">
              <label
                      for="exsbposition_reason"
                      class="form-control-label">{{$t('views.exsbdocument.form.positions.reason')}}:</label>
              <fg-input :error="violations.delivery">
                <el-select
                        id="exsbposition_reason"
                        :class="['select-default', isInvalid('reason') ? 'select-danger' : '']"
                        :placeholder="$t('views.exsbdocument.form.positions.reason')"
                        filterable
                        v-model="documentPosition.reason">
                  <el-option v-for="option in reasons"
                             class="select-default"
                             :value="option['@id']"
                             :label="option.name"
                             :key="option['@id']">
                  </el-option>
                </el-select>
              </fg-input>
              <div
                      v-if="isInvalid('reason')"
                      class="invalid-feedback">{{ violations.reason }}</div>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label
                      for="exsbposition_reasonComment"
                      class="form-control-label">{{$t('views.exsbdocument.form.positions.reasonComment')}}:</label>
              <input
                      id="exsbposition_reasonComment"
                      v-model="documentPosition.reasonComment"
                      :class="['form-control', isInvalid('reasonComment') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('reasonComment', $event.target.value)">
              <div
                      v-if="isInvalid('reasonComment')"
                      class="invalid-feedback">{{ violations.reasonComment }}</div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button v-if="!ordersDocument" class="btn btn-danger float-right" size="sm" @click="removeItemCollection(index)">{{$t('buttons.delete')}}</b-button>
            <b-button v-b-toggle="'collapse-' + index" variant="default" size="sm" class="float-right">{{$t('buttons.redoCollapse')}}</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr>
          </b-col>
        </b-row>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import currencyFieldConverter from '@/utils/currencyFieldConverter'
import ApiService from '@/utils/ApiService'
export default {
  name: 'Position',
  props: {
    ordersDocument: {
      type: Boolean,
      default: false
    },
    documentPosition: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    violations: {
      type: Object,
      required: true
    },
    handleUpdateField: {
      type: Function,
      required: true
    },
    itemsArray: {
      type: Array,
      required: true
    },
    warehouses: {
      type: Array,
      required: true
    },
    vatRates: {
      type: Array,
      required: true
    },
    reasons: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    documentPositions: {
      type: Array,
      required: true
    },
    documentType: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      documentPositionHeader: '',
      showCollapse: true
    }
  },

  created () {
    this.unwatchDiscount = this.$watch(
      function () {
        return this.documentPosition.discount
      },
      function (newValue) {
        this.discountFieldConverter(newValue)
      }
    )
    this.createPriceWatchers()
    this.createQuantityWatcher()
    this.createItemWatcher()
    this.createVatRateWatcher()
    this.createWarehouseWatcher()
    this.createNewWarehouseWatcher()
  },

  methods: {
    changeItemHandle (value) {
      for (var i in this.itemsArray) {
        if (this.itemsArray[i]['@id'] === this.documentPosition.item) {
          let item = this.itemsArray[i]
          this.documentPositionHeader = ' - ' + item.name
          this.unwatchPricePerUnitBrutto()
          this.unwatchVatRate()
          this.documentPosition.vatRate = item.vatRate['@id']
          this.documentPosition.pricePerUnitNetto = item.priceNetto.toString()
          this.documentPosition.measure = item.measure['@id']
          this.createVatRateWatcher()
        }
      }
    },

    pricePerUnitNettoToPricePerUnitBrutto (value, maxDecimalPlaces) {
      this.unwatchPricePerUnitNetto()
      this.unwatchPricePerUnitBrutto()
      var vatRate = 0
      for (var i in this.vatRates) {
        if (this.documentPosition.vatRate['@id']) {
          if (this.vatRates[i]['@id'] === this.documentPosition.vatRate['@id']) {
            vatRate = parseInt(this.vatRates[i].value)
            if (isNaN(vatRate)) {
              vatRate = 0
            }
          }
        } else {
          if (this.vatRates[i]['@id'] === this.documentPosition.vatRate) {
            vatRate = parseInt(this.vatRates[i].value)
            if (isNaN(vatRate)) {
              vatRate = 0
            }
          }
        }
      }
      value = this.getCurrencyValue(value, 2, false)
      this.documentPosition.pricePerUnitNetto = value.text
      let brutto = parseFloat((value.number * (vatRate / 100)) + value.number).toFixed(maxDecimalPlaces)
      this.documentPosition.pricePerUnitBrutto = brutto
      let quantity = this.documentPosition.quantity
      this.calculateValuesNetto(quantity, value.number)
      this.calculateValuesBrutto(quantity, brutto)
      this.createPriceWatchers()
    },

    pricePerUnitBruttoToPricePerUnitNetto (value, maxDecimalPlaces) {
      this.unwatchPricePerUnitNetto()
      this.unwatchPricePerUnitBrutto()
      for (var i in this.vatRates) {
        if (this.vatRates[i]['@id'] === this.documentPosition.vatRate) {
          var vatRate = parseInt(this.vatRates[i].value)
          if (isNaN(vatRate)) {
            vatRate = 0
          }
        }
      }
      value = this.getCurrencyValue(value, 2, false)
      this.documentPosition.pricePerUnitBrutto = value.text
      let netto = parseFloat((value.number / ((100 + vatRate) / 100))).toFixed(maxDecimalPlaces)
      this.documentPosition.pricePerUnitNetto = netto
      let quantity = this.documentPosition.quantity
      this.calculateValuesBrutto(quantity, value.number)
      this.calculateValuesNetto(quantity, netto)
      this.createPriceWatchers()
    },

    calculateValuesNetto (quantity, price) {
      if (quantity !== undefined && quantity !== null && quantity !== '') {
        this.unwatchQuantity()
        this.documentPosition.valueNetto = (price * parseFloat(quantity)).toFixed(2)
        this.createQuantityWatcher()
      }
    },

    calculateValuesBrutto (quantity, price) {
      if (quantity !== undefined && quantity !== null && quantity !== '') {
        this.unwatchQuantity()
        this.documentPosition.valueBrutto = (price * parseFloat(quantity)).toFixed(2)
        this.createQuantityWatcher()
      }
    },

    discountFieldConverter (value) {
      value = value.replace(/\D/g, '')
      if (value !== '') {
        value = parseFloat(value)
        if (value < 0) {
          value = 0
        } else if (value > 100) {
          value = 100
        }
      }
      this.documentPosition.discount = value.toString()
    },

    createVatRateWatcher () {
      this.unwatchVatRate = this.$watch(
        function () {
          return this.documentPosition.vatRate
        },
        function (newValue) {
          // console.log(newValue)
        }
      )
    },

    createItemWatcher () {
      this.unwatchItem = this.$watch(
        function () {
          return this.documentPosition.item
        },
        function (newValue) {
          this.changeItemHandle(newValue)
          this.newWarehouseQuantity()
          this.warehouseQuantity()
        }
      )
    },

    createWarehouseWatcher () {
      this.unwatchWarehouse = this.$watch(
        function () {
          return this.documentPosition.warehouse
        },
        function (newValue) {
          this.warehouseQuantity()
        }
      )
    },

    createNewWarehouseWatcher () {
      this.unwatchNewWarehouse = this.$watch(
        function () {
          return this.documentPosition.newWarehouse
        },
        function (newValue) {
          this.newWarehouseQuantity()
        }
      )
    },

    createQuantityWatcher () {
      this.unwatchQuantity = this.$watch(
        function () {
          return this.documentPosition.quantity
        },
        function (newValue) {
          if (newValue < 0) {
            this.documentPosition.quantity = 0
            newValue = 0
          }
          this.calculateValuesNetto(newValue, this.documentPosition.pricePerUnitNetto)
          this.calculateValuesBrutto(newValue, this.documentPosition.pricePerUnitBrutto)
        }
      )
    },

    createPriceWatchers () {
      this.unwatchPricePerUnitNetto = this.$watch(
        function () {
          return this.documentPosition.pricePerUnitNetto
        },
        function (newValue) {
          this.pricePerUnitNettoToPricePerUnitBrutto(newValue, 2)
        }
      )
      this.unwatchPricePerUnitBrutto = this.$watch(
        function () {
          return this.documentPosition.pricePerUnitBrutto
        },
        function (newValue) {
          this.pricePerUnitBruttoToPricePerUnitNetto(newValue, 2)
        }
      )
    },

    removeItemCollection (index) {
      this.documentPositions.splice(index, 1)
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },

    getCurrencyValue (netto, maxDecimalPlaces, minus) {
      return currencyFieldConverter(netto, maxDecimalPlaces, minus)
    },
    async newWarehouseQuantity () {
      if (this.documentPosition.newWarehouse && this.documentPosition.item) {
        const response = await new ApiService('e_x_s_b_warehouse_items?warehouse=' + this.documentPosition.newWarehouse + '&item=' + this.documentPosition.item).getResults()
        if (response.items && response.items.length > 0) {
          this.documentPosition.newWarehouseQuantity = response.items[0].quantity
        } else {
          this.documentPosition.newWarehouseQuantity = 0
        }
      } else {
        this.documentPosition.newWarehouseQuantity = 0
      }
    },
    async warehouseQuantity () {
      if (this.documentPosition.warehouse && this.documentPosition.item) {
        const response = await new ApiService('e_x_s_b_warehouse_items?warehouse=' + this.documentPosition.warehouse + '&item=' + this.documentPosition.item).getResults()
        if (response.items && response.items.length > 0) {
          this.documentPosition.warehouseQuantity = response.items[0].quantity
        } else {
          this.documentPosition.warehouseQuantity = 0
        }
      } else {
        this.documentPosition.warehouseQuantity = 0
      }
    }
  }
}
</script>
